import "@/App.css";
import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import NotFound from "@/pages/NotFound";
import { Toaster } from "@/components/ui/sonner";
import { findVille } from "@/data/villes";

// Home (page d'entrée la plus visitée, critique pour le LCP) et NotFound
// (utilisée directement dans CatchAll ci-dessous) restent en import direct.
// Les autres pages passent en chargement différé : leur code ne fait plus
// partie du bundle initial de "/", seulement de la route qui les affiche.
const Services = lazy(() => import("@/pages/Services"));
const ServicePage = lazy(() => import("@/pages/ServicePage"));
const Tarifs = lazy(() => import("@/pages/Tarifs"));
const Zones = lazy(() => import("@/pages/Zones"));
const FAQ = lazy(() => import("@/pages/FAQ"));
const Contact = lazy(() => import("@/pages/Contact"));
const Ville = lazy(() => import("@/pages/Ville"));
const Blog = lazy(() => import("@/pages/Blog"));
const Article = lazy(() => import("@/pages/Article"));
const MentionsLegales = lazy(() => import("@/pages/MentionsLegales"));
const Confidentialite = lazy(() => import("@/pages/Confidentialite"));

function RouteFallback() {
  return (
    <div
      className="flex items-center justify-center gap-2"
      style={{ minHeight: "60vh" }}
      aria-busy="true"
      aria-live="polite"
      data-route-loading="true"
    >
      <span className="pulse-dot" aria-hidden="true"></span>
      <span className="font-mono text-xs uppercase tracking-widest" style={{ color: "var(--ink-muted)" }}>
        Chargement…
      </span>
    </div>
  );
}

// React Router v7 ne supporte pas "/serrurier-:slug" (prefix+param dans un
// même segment). On garde les URLs exigées par le brief en parsant le
// pathname manuellement dans un fallback route.
function CatchAll() {
  const { pathname } = useLocation();
  const match = pathname.match(/^\/serrurier-([a-z0-9-]+)\/?$/i);
  if (match && findVille(match[1])) {
    return <Ville forcedSlug={match[1]} />;
  }
  return <NotFound />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServicePage />} />
              <Route path="/tarifs" element={<Tarifs />} />
              <Route path="/zones-intervention" element={<Zones />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<Article />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/confidentialite" element={<Confidentialite />} />
              <Route path="*" element={<CatchAll />} />
            </Routes>
          </Suspense>
        </Layout>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
